import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import StarRating from './StarRating';
import locationIcon from '../assets/images/location-pin.svg'; // You may need to create this icon
import arrowIcon from '../assets/images/user/clarity_arrow-line.png';
import axios from 'axios';
import LawyerCard from './lawyer/LawyerCard';

// Sample data for lawyer cards
const sampleLawyers = [
  {
    id: 1,
    name: "J M WILSON SOLICITORS LIMITED",
    firm: "",
    location: "Birmingham",
    rating: 5,
    reviews: 3,
    service: "Litigation - Other",
    isOnline: false,
    photo: null,
    isVerified: true,
    teamPhoto: "https://source.unsplash.com/random/600x400/?legal,team"
  },
  {
    id: 2,
    name: "Marcus Lindsey Hurst",
    firm: "",
    location: "Birmingham",
    rating: 5,
    reviews: 3,
    service: "Litigation - Other",
    isOnline: false,
    photo: null,
    isVerified: true
  },
  {
    id: 3, 
    name: "Grant Alexander Folland",
    firm: "",
    location: "Birmingham",
    rating: 5,
    reviews: 3,
    service: "Litigation - Other",
    isOnline: false,
    photo: null,
    isVerified: true
  },
  {
    id: 4,
    name: "J M WILSON SOLICITORS LIMITED",
    firm: "",
    location: "Birmingham",
    rating: 5,
    reviews: 3,
    service: "Litigation - Other",
    isOnline: false,
    photo: null,
    isVerified: false
  },
  {
    id: 5,
    name: "J M WILSON SOLICITORS LIMITED",
    firm: "",
    location: "Birmingham",
    rating: 5,
    reviews: 3,
    service: "Litigation - Other",
    isOnline: false,
    photo: null,
    isVerified: false
  },
  {
    id: 6,
    name: "J M WILSON SOLICITORS LIMITED",
    firm: "",
    location: "Birmingham",
    rating: 5,
    reviews: 3,
    service: "Litigation - Other",
    isOnline: false,
    photo: null,
    isVerified: false
  }
];

// Filter types for the search results
const filterOptions = [
  { id: 'all', label: 'All' },
  { id: 'online', label: 'Online Now' },
  { id: 'top-rated', label: '5 Star Only' }
];

const NoResultsState = () => (
  <div className="search-results__no-results">
    <div className="search-results__no-results-icon">
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#8B76E3"/>
      </svg>
    </div>
    <h3 className="search-results__no-results-title">No results found</h3>
    <p className="search-results__no-results-text">
      Try adjusting your filters or selecting different search criteria
    </p>
  </div>
);

const SearchResults = ({ 
  totalMatches = 36, 
  lawyers = sampleLawyers,
  serviceType = "Family law",
  location = "Birmingham",
  onLoadMore,
  hasMore = false
}) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [filteredLawyers, setFilteredLawyers] = useState(lawyers);
  const lawyersRef = useRef(null);
  
  // Function to check if lawyers array has changed
  const haveLawyersChanged = (prevLawyers, currentLawyers) => {
    // Quick length check
    if (prevLawyers?.length !== currentLawyers?.length) {
      return true;
    }
    
    // Quick reference check
    if (prevLawyers === currentLawyers) {
      return false;
    }
    
    // More thorough check for changes
    try {
      const prevIds = prevLawyers?.map(l => l.id)?.join(',') || '';
      const currentIds = currentLawyers?.map(l => l.id)?.join(',') || '';
      return prevIds !== currentIds;
    } catch (error) {
      console.error('Error comparing lawyer arrays:', error);
      return true;  // If we can't compare, assume they're different
    }
  };
  
  // Update filtered lawyers when the activeFilter or lawyers change
  useEffect(() => {
    // Only update if lawyers have actually changed
    if (!haveLawyersChanged(lawyersRef.current, lawyers)) {
      return;
    }
    
    // Store the new lawyers array in ref
    lawyersRef.current = lawyers;
    
    console.log('Filtering lawyers with filter:', activeFilter);
    let filtered = lawyers || [];
    
    if (activeFilter === 'online') {
      filtered = filtered.filter(lawyer => lawyer.isOnline);
    } else if (activeFilter === 'top-rated') {
      filtered = filtered.filter(lawyer => lawyer.rating === 5);
    }
    
    setFilteredLawyers(filtered);
  }, [lawyers, activeFilter]);
  
  // Handle filter changes
  const handleFilterChange = (filterId) => {
    if (filterId === activeFilter) return;
    setActiveFilter(filterId);
  };
  
  return (
    <div className="search-results">
      <div className="search-results__header">
        <h2 className="search-results__title">
          Great news! We've found you<br />
          <span className="search-results__highlight">{totalMatches} matches</span>
        </h2>
      </div>
      
      {filteredLawyers.length > 0 ? (
        <>
          <div className="search-results__grid">
            {filteredLawyers.map(lawyer => (
              <LawyerCard key={lawyer.id} lawyer={lawyer} isSearchResult={true} />
            ))}
          </div>
          
          {hasMore && (
            <div className="search-results__load-more">
              <button 
                className="search-results__load-more-btn"
                onClick={onLoadMore}
              >
                Load more results
              </button>
            </div>
          )}
        </>
      ) : (
        <NoResultsState />
      )}
    </div>
  );
};

export default SearchResults; 